import api from './index';

const baseEndpoint = 'payment/v1';

export default {
  getPaymentMethods( ) {
    return api.get( `${baseEndpoint}/adyen/paymentMethods`, { channel: 'WEB', countryCode: 'PT' } );
  },
  createFinancialCard( username: string, params: any ) {
    return api.post( `account/v1/accounts/${username}/financialCards`, params );
  },
};
